import { useDraggable, TableRow, TableBodyCell } from '@pocketlaw/tetris';
import { DocumentStatusChip } from 'app/domains/documents';
import { ContextMenuCell, DateCell, NameCell } from './TableCells';
import { getFileType } from './utils';
export default function DocumentTableRow(props) {
    const { id, type, documentType, name, status = '', date, accessLevel, onDuplicate, onRename, onMove, onDelete, onEditAccess, } = props;
    const { draggableProps } = useDraggable(`${type}:${id}`);
    const openUrl = `/document/${id}`;
    const fileType = getFileType(documentType);
    return (<TableRow {...draggableProps}>
      <NameCell headers="filesystemtable-name" to={openUrl} title={name} type={fileType}/>
      <TableBodyCell headers="filesystemtable-status">
        <DocumentStatusChip size="small" documentId={id} status={status}/>
      </TableBodyCell>
      <DateCell headers="filesystemtable-updatedAt" date={date}/>
      <ContextMenuCell download accessLevel={accessLevel} documentId={id} openUrl={openUrl} onDuplicate={onDuplicate} onRename={onRename} onMove={onMove} onDelete={onDelete} onEditAccess={onEditAccess}/>
    </TableRow>);
}
